import { Injectable } from '@angular/core';
import { AuthHttpService } from '../auth-data/auth-http.service';
import { DocumentDataService } from '../document-data/document-data.service';
import { ITopLevelKeys } from '../entity-data/entity-data.data';
import { ErrorService } from '../error-reporting/error.service';
import { RendererService } from '../renderer/renderer.service';
import { GlobalSearch } from '../search-data/global-search.model';
import { SettingsDataStore } from '../settings-data/settings-data.store';
import { LoggerService } from '../shared/services/logger/logger.service';
import { PurchaseOrderDataBuilder } from './purchase-order-data.builder';

@Injectable()
export class PurchaseOrderDataService extends DocumentDataService {
  topLevelKeys: ITopLevelKeys = {
    getKey: 'purchase_order_snippets',
    postKey: 'created_purchase_order',
    putKey: 'updated_purchase_order',
    deletedKey: 'deleted_purchase_orders',
    deleteSingleKey: 'deleted_purchase_order',
    getSingleKey: 'purchase_order',
    searchResultsKey: 'purchase_order_results',
    globalSearchResultsKey: GlobalSearch.KEYS.PURCHASE_ORDERS,
  };

  constructor(
    authHttpService: AuthHttpService,
    loggerService: LoggerService,
    errorService: ErrorService,
    rendererService: RendererService,
    purchaseOrderDataBuilder: PurchaseOrderDataBuilder,
    settingsDataStore: SettingsDataStore
  ) {
    super(
      '/purchase_orders',
      authHttpService,
      purchaseOrderDataBuilder,
      loggerService,
      rendererService,
      errorService,
      settingsDataStore
    );
  }
}
